export class SellerChurnTemplateConstants {
}
SellerChurnTemplateConstants.HistoricalSummaryOutput = 'Historical Summary';
SellerChurnTemplateConstants.HistoricalChurned = 'HistoricalChurned';
SellerChurnTemplateConstants.HistoricalChurnedCount = 'HistoricalChurnedCount';
SellerChurnTemplateConstants.SegmentationOutput = 'Segmentation';
SellerChurnTemplateConstants.SegmentationSegment = 'Segment';
SellerChurnTemplateConstants.SegmentationSummaryOutput = 'Segmentation Summary';
SellerChurnTemplateConstants.SegmentationSummarySegmentID = 'SegmentID';
SellerChurnTemplateConstants.SegmentationSummaryName = 'Name';
SellerChurnTemplateConstants.SegmentationSummaryProbability = 'Probability';
SellerChurnTemplateConstants.SegmentationSummaryColumn = 'Column';
SellerChurnTemplateConstants.SegmentationSummaryOperator = 'Operator';
SellerChurnTemplateConstants.SegmentationSummaryValue = 'Value';
SellerChurnTemplateConstants.SegmentationSummaryCount = 'Count';
// If you change this, you add to change the UI to support old Apps, such as findRevenueColumnIndex
SellerChurnTemplateConstants.SegmentationSummaryRevenue = 'Performance';
SellerChurnTemplateConstants.PredictedChurnOutput = 'Predicted Churn';
SellerChurnTemplateConstants.PredictedChurnSeller = 'Seller';
SellerChurnTemplateConstants.PredictedChurnPredictChurn = 'PredictChurn';
SellerChurnTemplateConstants.PredictedChurnPredictChurnPct = 'PredictChurnPct';
SellerChurnTemplateConstants.PredictedChurnRevenue = 'Revenue';
SellerChurnTemplateConstants.PredictedChurnSummaryOutput = 'Predicted Churn Summary';
SellerChurnTemplateConstants.PredictedChurnSummaryChurned = 'Churned';
SellerChurnTemplateConstants.PredictedChurnSummaryChurnedCount = 'Churned Count';
SellerChurnTemplateConstants.SellerValueQuadrantOutput = 'Seller Value Quadrant';
SellerChurnTemplateConstants.SellerValueQuadrantSellerName = 'SellerName';
SellerChurnTemplateConstants.SellerValueQuadrantPredictChurnPct = 'PredictChurnPct';
SellerChurnTemplateConstants.SellerValueQuadrantRevenue = 'Revenue';
SellerChurnTemplateConstants.DataElementID = 'LW3TuKAvVC6UKw';
SellerChurnTemplateConstants.RenameInputColumnsElementID = 'dV43Pm2_kqD5IA';
SellerChurnTemplateConstants.HistoricalConditionalElementID = 'qLPTjfRtwnEUZQ';
SellerChurnTemplateConstants.FilterAlreadyChurnedElementID = 'ZxVdvvl21az3Eg';
SellerChurnTemplateConstants.PredictionConditionalElementID = 'mKBZO-3y2BUcPQ';
SellerChurnTemplateConstants.PredictionAggregateElementID = '98TlhKN229aYFQ';
SellerChurnTemplateConstants.SellerValueQuadrantRenameElementID = 'sVlP2Ye6wTAdbg';
SellerChurnTemplateConstants.ClassifierElementID = 'LxTSot8yoOJmEg';
SellerChurnTemplateConstants.ReservedColumnNames = [
    'PredictionValue',
    SellerChurnTemplateConstants.HistoricalChurned,
    SellerChurnTemplateConstants.HistoricalChurnedCount,
    SellerChurnTemplateConstants.SegmentationSummarySegmentID,
    SellerChurnTemplateConstants.SegmentationSummaryName,
    SellerChurnTemplateConstants.SegmentationSummaryProbability,
    SellerChurnTemplateConstants.SegmentationSummaryColumn,
    SellerChurnTemplateConstants.SegmentationSummaryOperator,
    SellerChurnTemplateConstants.SegmentationSummaryValue,
    SellerChurnTemplateConstants.SegmentationSummaryCount,
    SellerChurnTemplateConstants.SegmentationSummaryRevenue,
    SellerChurnTemplateConstants.PredictedChurnSeller,
    SellerChurnTemplateConstants.PredictedChurnPredictChurn,
    SellerChurnTemplateConstants.PredictedChurnPredictChurnPct,
    SellerChurnTemplateConstants.PredictedChurnRevenue,
    SellerChurnTemplateConstants.PredictedChurnSummaryChurned,
    SellerChurnTemplateConstants.PredictedChurnSummaryChurnedCount,
    SellerChurnTemplateConstants.SellerValueQuadrantSellerName,
    SellerChurnTemplateConstants.SellerValueQuadrantPredictChurnPct,
    SellerChurnTemplateConstants.SellerValueQuadrantRevenue
];
//# sourceMappingURL=sellerChurnTemplateConstants.js.map